<template>
  <div class="card">
    <h5 class="card-header text-truncate w-100">Salidas recientes de inventario</h5>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table mb-0 table-nowrap align-middle" id="salidas-recientes" style="min-height: 250px;">
          <thead>
            <tr>
              <th style="width:40px"></th>
              <th>Nombre</th>
              <th>Cantidad</th>
              <th>Fecha de entrega</th>
              <th>Salida</th>
              <!-- <th>Solicitante</th> -->
            </tr>
          </thead>
          <tbody>
            <tr style="font-size: 15px;" v-for="movimiento in movimientos" :key="movimiento.id">
              <td>
                <div style="min-height: 30px; display: inline-block">
                  <a
                    href="#"
                    onclick="return false;"
                    @click="mostarGaleriaFotosArticulo(movimiento.id_articulo)"
                    v-if="movimiento.foto_principal_articulo"
                  >
                    <img 
                      :src="`${API}/articulos/${movimiento.id_articulo}/fotos/principal?tipo_foto=64x64&_tk=${tk}`"
                      style="width:30px; height:30px;"
                      class="rounded-circle"
                    />
                  </a>
                  <img
                    v-if="!movimiento.foto_principal_articulo"
                    :src="inventarioIcon"
                    style="width:30px; height:30px;"
                    class="rounded-circle"
                  />
                </div>
              </td>
              <td>
                {{movimiento.nombre_articulo}}
              </td>
              <td>
                {{movimiento.cantidad}}
                {{movimiento.abreviatura_unidad_medida}}
              </td>
              <td>
                {{formatoFecha(movimiento.fecha)}}
              </td>
              <td style="width:170px">
                <router-link :to="{ name: 'visorSalidaAlmacen', params: { id: movimiento.id_salida } }"
                  class="btn btn-outline-secondary btn-sm">
                  <i class="mdi mdi-eye"></i>
                  Mostrar salida {{movimiento.id_salalm}}
                </router-link>
              </td>
              <!-- <td>
                {{movimiento.nombre_solicitante}}
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <cmp-galeria-fotos 
      ref="salidas_recientes_articulo"
      :nombreGaleria="'salidas_recientes_articulo'"
    />
  </div>
</template>

<script>
import MovimientoArticulosSrv from '@/services/inventario/MovimientoArticulosSrv.js'
import inventarioIcon from '@/assets/img/inventario/inventario.png'
import CmpGaleriaFotos from "../CmpGaleriaFotos.vue"
import {APIINV as API} from '@/API.js'

import moment from 'moment'

export default {
  name: 'WSalidasRecientesInventario',
  components: {
    CmpGaleriaFotos
  },
  data() {
    return {
      API: API,
      tk: localStorage.getItem('argusblack.token'),
      inventarioIcon: inventarioIcon,
      movimientos: []
    }
  },
  created(){
    var self = this
    setTimeout(() => {
      self.refrescarMovimientos()
    }, 500)

  },
  methods: {
    mostarGaleriaFotosArticulo: function(idArticulo) {
      var self = this
      self.$refs.salidas_recientes_articulo.mostrarGaleria(idArticulo)
    },

    formatoFecha(mt) {
      return moment(mt, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
    },
    
    refrescarMovimientos: function() {
      var self = this

      iu.spinner.mostrar('#salidas-recientes')

      let params = {
        limite:5
      }
      
      MovimientoArticulosSrv.ultimasSalidasJSON(params).then(response => {
        let page = response.data
        self.movimientos = page
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudieron cargar los ultimos movimientos de entradas'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally (() => {
        iu.spinner.ocultar('#salidas-recientes')
      })
    }
  },
  mounted: function() {
    iu.spinner.mostrar('#salidas-recientes')
  }
}
</script>

<style scoped>

</style>